const FORCE_COLLECT_STORAGE_KEY = 'inventory_force_collect_followed_state_id';

// Upper bound on how long a stored force-collect reference stays valid after
// a page reload. Keep in sync with MAX_POLLING_DURATION_MS in
// use-force-inventory-collection.ts — both must exceed the backend
// once_only_task lock TTL so long-running collections survive a reload.
const MAX_AGE_MS = 960_000; // 16 minutes

interface StoredForceCollect {
  id: number;
  startedAt: number;
}

export const getStoredFollowedStateId = (): number | null => {
  const raw = localStorage.getItem(FORCE_COLLECT_STORAGE_KEY);
  if (!raw) return null;

  try {
    const parsed: StoredForceCollect = JSON.parse(raw);
    if (typeof parsed.id !== 'number' || typeof parsed.startedAt !== 'number') {
      clearStoredFollowedStateId();
      return null;
    }
    if (Date.now() - parsed.startedAt > MAX_AGE_MS) {
      clearStoredFollowedStateId();
      return null;
    }
    return parsed.id;
  } catch {
    // Handle legacy format (plain number string) — just clear it
    clearStoredFollowedStateId();
    return null;
  }
};

export const setStoredFollowedStateId = (stateId: number): void => {
  const data: StoredForceCollect = { id: stateId, startedAt: Date.now() };
  localStorage.setItem(FORCE_COLLECT_STORAGE_KEY, JSON.stringify(data));
};

export const clearStoredFollowedStateId = (): void => {
  localStorage.removeItem(FORCE_COLLECT_STORAGE_KEY);
};
